import type { Component, Ref } from "vue"

export type ConstantsMap<
  TValue extends string | number = string | number,
> = Record<
  string,
  {
    value: TValue
    label: string
    icon?: Component
  }
>

export const buildOptionsFromConstantsMap = <
  TValue extends string | number,
>(
  constantsMap: ConstantsMap<TValue>
) => Object.values(constantsMap)

export type Option<
  TValue = string | number | undefined | null,
> = {
  value: TValue
  label: string
  icon?: Component
}

export type Options = Option[]

export type UseOptions = () => {
  options: Ref<Option[]>
  isFetching: Readonly<Ref<boolean>>
}
